export var getIds = id => id ? {
  root: id,
  leftEdge: "".concat(id, "__left-edge"),
  leftActionWrapper: "".concat(id, "__left-action-wrapper"),
  leftAction: "".concat(id, "__left-action"),
  leftIconWrapper: "".concat(id, "__left-icon-wrapper"),
  leftIcon: "".concat(id, "__left-icon"),
  textWrapper: "".concat(id, "__text-wrapper"),
  title: "".concat(id, "__title"),
  subtitle: "".concat(id, "__subtitle"),
  paragraph: "".concat(id, "__paragraph"),
  klarnaLogo: "".concat(id, "__klarna_logo"),
  rightEdge: "".concat(id, "__right-edge"),
  rightActionWrapper: "".concat(id, "__right-action-wrapper"),
  rightAction: "".concat(id, "__right-action"),
  rightIconWrapper: "".concat(id, "__right-icon-wrapper"),
  rightIcon: "".concat(id, "__right-icon")
} : undefined;
//# sourceMappingURL=getIds.js.map